import { CLASS_NAME } from '../../../constants/class-names'
import { EventType } from '../../../constants/enums'

import { ComponentBase } from 'utils/abstract-classes/component-base'

export class SliderComponent extends ComponentBase {
    /**
     * Initializes the slider
     * @param {HTMLInputElement} slider
     */
    public constructor(private slider: HTMLInputElement) {
        super()
        const sliderActiveClass = CLASS_NAME.slider.active

        this.slider.addEventListener(EventType.CHANGE, () => {
            if (this.slider.checked) {
                document.documentElement.classList.add(sliderActiveClass)
            } else {
                document.documentElement.classList.remove(sliderActiveClass)
            }
        })
    }
}
